import React, { useState, useEffect } from "react";
import SingleQuestion from "../../components/faq/index";
import QAdata from "./question";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import "./styles.css";
import { meta } from "../../content_option";
import Footer from "../../components/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import Typewriter from 'typewriter-effect';
import faq from "../../assets/videos/faq.mp4";

const FAQ = () => {
  const [questions, setQuestions] = useState(QAdata);

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <HelmetProvider>

      <Helmet>
        <meta charSet="utf-8" />
        <title>FAQ's | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div style={{
         pointerEvents: 'none',  
          position: 'relative'
      }}>
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid fq"
          playsInline
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          style={{
            // height: "38vh",
            width: "100%",
            // position: "relative",
            objectFit: "fill",
            // zIndex: "-1",
            // top: 0,
            pointerEvents: 'none',  // Extra protection against interaction
            userSelect: 'none',     // Prevent text selection
            WebkitTouchCallout: 'none'
          }}
        ></video>

      </div>

      <Container className="faqContainer" style={{ display: "flex", flexDirection: 'column', alignItems: 'center', marginTop: "20px" ,marginBottom:"-15px"}}>
        <Row  >

          <h2 className="faq" >Frequently Asked Questions</h2>


        </Row>

        <section className="faq-container" style={{ marginTop: "20px" ,marginBottom:"70px"}}>

          {questions.map((question, id) => (
            <SingleQuestion
              key={question.id}
              {...question}
              data-aos={id % 2 === 0 ? "fade-right" : "fade-left"}
            />
          ))}

        </section>

      </Container>
      <div className="test-container  "style={{ marginBottom:"100px"}} >
        <div className="innerQuote">
          <Row className="testimonial   ">
            <h2>
              “Made in Heaven's approach to videography, focusing on genuine emotions and candid moments with our families and friends, truly made our wedding videos come alive. As we watched, we were transported back to every behind-the-scenes moment, feeling the love and laughter all over again. Thank you, Made in Heaven, for capturing the heart and soul of our special day in such a beautiful way” <br /> – HARNEET AND JORDAN
            </h2>
            <div className="typewriter-container">
              <Typewriter
                options={{
                  strings: ['RAW', 'REFINED', 'RIVETING'],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 20,
                }}
              />
            </div>
          </Row>
        </div>

      </div>
      <Footer />
    </HelmetProvider>
  );
};

export default FAQ;